import { render, staticRenderFns } from "./JoinSequence.vue?vue&type=template&id=671d2fdf&scoped=true&"
import script from "./JoinSequence.vue?vue&type=script&lang=ts&"
export * from "./JoinSequence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d2fdf",
  null
  
)

export default component.exports